import { unreadMessageCountApi } from '@/api/index'
import { getToken } from '@/utils/auth'

const message = {
  state: {
    messageInfo: null,
    notice: true,
    unreadMessageCount: 0 // 未读消息数量
  },
  mutations: {
    setMessageInfo(state, info) {
      state.messageInfo = info;
    },
    setNoticeDisplay(state, status) {
      state.notice = status;
    },
    setUnreadMessageCount(state, count) {
      state.unreadMessageCount = count
    }
  },
  actions: {
    // 获取未读消息数量
    getUnreadMessageCount({ commit, rootState }) {
      if(!getToken()) return;
      const params = {
        source: rootState.user.platform
      }
      return unreadMessageCountApi(params).then(res => {
        commit('setUnreadMessageCount', res.data || 0)
      })
    }
  },
};

export default message
